"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingupService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const personOriginCat_enum_1 = require("../enum/personOriginCat.enum");
class SingupService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'user';
        this.signup = async (userData, querystr, isSSO, useLocationProtocol = true) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/signup`;
            // Determina el valor de location basado en el parámetro useLocationProtocol
            const location = useLocationProtocol ? window.location.host : null;
            const protocol = useLocationProtocol ? window.location.protocol : null;
            const user = {
                first_name: userData.first_name,
                last_name: userData.last_name,
                gender: userData.gender,
                email: userData.email,
                phone: userData.phone,
                referer_id: userData.referer_id === "" ? null : userData.referer_id,
                location: useLocationProtocol ? protocol + '//' + location : null,
                queryStr: querystr,
                sso: isSSO ? isSSO : false,
                crm_id: userData.crm_id ? userData.crm_id : null,
                origin_id: userData.origin_id ? userData.origin_id : personOriginCat_enum_1.PERSON_ORIGIN_CAT.SIGNUP
            };
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.validateToken = async (token, loading, error) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/password/validate-token`;
            loading(true);
            const response = await axios_1.default.post(URL, JSON.stringify({ token: token }), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                loading(false);
                return Promise.resolve(response.data.valid_token);
            }
            else {
                error('El enlace ha expirado, Intenta recuperar tu contraseña.');
                return Promise.reject(response.statusText);
            }
        };
        this.updatePassword = async (userData, token) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/password/`;
            const { password } = userData;
            const payload = {
                password: password,
                token: token
            };
            const response = await axios_1.default.put(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updatePasswordSSO = async (token) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/password/active-directory`;
            const payload = {
                token: token
            };
            const response = await axios_1.default.put(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.forgotPassword = async (email) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/password/forgot/`;
            const location = window.location.host;
            const protocol = window.location.protocol;
            const payload = {
                email: email,
                location: protocol + '//' + location,
            };
            const response = await axios_1.default.put(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.activateSSOAccount = async (userData, token) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/activate/`;
            const { password } = userData;
            const payload = {
                password: password,
                token: token
            };
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.validateEmail = async (email) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/signup/validate-email`;
            const payload = { email: email };
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.talisisAccountActivation = async (userData, token, environment) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/activate-account/`;
            const { password } = userData;
            const payload = {
                password: password,
                password_token: token,
                environment: environment
            };
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Reenvía la activación de correo electrónico a una lista de correos electrónicos proporcionada en el payload.
         * @param {object} payload - El payload que contiene la información necesaria para la solicitud.
         * @param {string} payload.env - El entorno en el que se ejecuta la solicitud (por ejemplo, 'dev').
         * @param {Array<string>} payload.emails - La lista de correos electrónicos a los que se reenviará la activación.
         * @returns {Promise<any>} - La respuesta del servidor.
        */
        this.talisisResendActivation = async (payload) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/signup/resend-activation`;
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.SingupService = SingupService;
